import {
  IProject,
  IServiceMenuComponent,
} from '@/interfaces/interfaceCatalogs';
import { InputSwitchChangeEvent } from 'primereact/inputswitch';
import { classNames } from 'primereact/utils';

import { ButtonComponent } from '../../../../components/ButtonComponen';
import { InputComponent } from '../../../../components/InputComponent';
import { SwitchComponent } from '../../../../components/SwitchComponent';
import { ProjectValidations } from './validations_form';
import useCustomFormik from './utils/formik_catalog_Config';

export const ProjectForm = (props: IServiceMenuComponent) => {
  const { serviceCatalog } = props;

  const renderMenu = (): any => {
    return (
      <form
        className="h-full w-full flex flex-col pt-5 px-6"
        onSubmit={serviceCatalog.formikProject.handleSubmit}>

        <div className="flex flex-col">
          <InputComponent
            label={'Nombre'}
            type={'text'}
            name={'name'}
            onChange={serviceCatalog.formikProject.handleChange}
            value={serviceCatalog.formikProject?.values?.['name']}
            placeholder={'Nombre'}
            className={classNames({
              'p-invalid': serviceCatalog.isFormFieldValid('name', serviceCatalog.formikProject.errors, serviceCatalog.formikProject.touched),
            })}
          />
          {serviceCatalog.getFormErrorMessage('name', serviceCatalog.formikProject.errors, serviceCatalog.formikProject.touched)}
        </div>

        <div className="flex flex-col">
          <SwitchComponent
            checked={serviceCatalog.formikProject?.values?.['status'] || 'false'}
            onChange={(e: InputSwitchChangeEvent) => {
              serviceCatalog.formikProject.setFieldValue('status', e.value);
            }}
            label={'Estatus'}
            className={classNames({
              'p-invalid': serviceCatalog.isFormFieldValid('status', serviceCatalog.formikProject.errors, serviceCatalog.formikProject.touched),
            })}
          />
          {serviceCatalog.getFormErrorMessage('status', serviceCatalog.formikProject.errors, serviceCatalog.formikProject.touched)}
        </div>

        <ButtonComponent className="mt-10" label={serviceCatalog.buttonLabel} type="submit" />
      </form>
    );
  };

  return (
    <div className="flex w-full h-full flex-col items-center bg-white  shadow-[-6px_-1px_5px_#00000024] z-10 right-0">
      <div className="flex w-full h-full overflow-y-auto">{renderMenu()}</div>
    </div>
  );
};
